import { Menu } from 'lucide-react';
import type { AdminUser } from '../types';

interface HeaderProps {
  user: AdminUser | null;
  onMenuToggle: () => void;
}

const Header = ({ user, onMenuToggle }: HeaderProps) => {
  return (
    <header className="bg-white shadow-lg border-b border-gray-200 fixed top-0 left-0 right-0 z-50">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Left side - Logo and Menu */}
          <div className="flex items-center">
            <button
              onClick={onMenuToggle}
              className="lg:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
            >
              <Menu size={20} />
            </button>
            
            <div className="ml-4 lg:ml-0">
              <h1 className="text-xl font-bold text-gray-900">
                Admin Panel
              </h1>
              <p className="text-xs text-gray-500">Drop of Change Management</p>
            </div>
          </div>

          {/* Right side - User info */}
          <div className="flex items-center space-x-4">
            {user && (
              <div className="flex items-center space-x-3">
                <div className="text-right hidden sm:block">
                  <div className="text-sm font-semibold text-gray-900">
                    {user?.name || 
                     (user?.firstName?.en || user?.firstName || 'User') + ' ' + 
                     (user?.lastName?.en || user?.lastName || '')}
                  </div>
                  <div className="text-xs text-gray-500 capitalize">
                    {user?.role?.replace('-', ' ') || 'admin'}
                  </div>
                </div>
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-sm">
                  <span className="text-sm font-semibold text-white">
                    {(() => {
                      const firstName = typeof user?.firstName === 'string' ? user.firstName : user?.firstName?.en;
                      return (user?.name || firstName || 'U').charAt(0).toUpperCase();
                    })()}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
